import { ILocationData } from 'meta/pages/v4/location'
import { SliceSelector } from 'store/types'

const getLocationData: SliceSelector<ILocationData | undefined, { idOrCodeUrl: string }> =
  ({ idOrCodeUrl }) =>
  (state) =>
    state.pages.location.data.locations[idOrCodeUrl]

export const LocationSelectors = {
  getLocationData,
}
